import React from 'react';
import { Box } from 'components';

const ContentContainer = ({ children }) => {
    return <Box p={ ['s', 'm']}>{ children }</Box>
}


export default ContentContainer;